module.exports = __webpack_public_path__ + "static/media/about-partner-carousel-6.a6e02617.png";